//HtmlMarker component is copied from https://github.com/Azure-Samples/azure-maps-html-marker-layer/tree/main/src
//Since azure atlas merge modules give hard time of install and import, here we copied code directly in to our project for typescript reference.
export * from './extended-html-marker';
export * from './htm-marker-layer-options';
export * from './html-marker-layer';
export * from './pie-chart-marker-options';
export * from './pie-chart-marker';
